import { RecordsTable } from "dyl-components";
import SubscriptionsTableHeader from "./SubscriptionsTableHeader";
import { useSelector } from "react-redux";
import Subscription from "./Subscription";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

const SubscriptionsTable = ({
    selectAllCheckbox,
    RowCheckboxComponent,
    onRestore,
    toRestore,
    hasOutstandingInvoices
}) => {
    const { subscriptions, count } = useSelector((state) => ({
        subscriptions: state.subscription.products,
        count: state.subscription.count,
    }));
    const [params] = useSearchParams();
    const isReadingProducts = useSelector(
        (state) => state.subscription.isReadingProducts
    );
    const location = useLocation();
    const navigate = useNavigate();

    const onPageChange = (_, { activePage }) => {
        const query = new URLSearchParams(location.search);
        query.set("page", activePage);
        const query_string = query.toString();

        navigate(`${location.pathname}${query_string ? `?${query_string}` : ""}`);
    };

    return (
        <RecordsTable
            tableBodyClassName="SubscriptionsTable"
            isTableLoading={isReadingProducts}
            isTableEmpty={count === 0}
            TableHeader={
                <SubscriptionsTableHeader
                    selectAllCheckbox={selectAllCheckbox}
                />
            }
            TableRows={subscriptions.map((subscription) => {
                const subscription_id = subscription.subscription_id;
                const restored = toRestore?.includes(subscription_id);
                return (
                    <Subscription
                        hasOutstandingInvoices={hasOutstandingInvoices}
                        RowCheckboxComponent={RowCheckboxComponent}
                        key={subscription_id}
                        id={subscription_id}
                        canceled={subscription.canceled}
                        productInfo={
                            <div>
                                <div>
                                    <b>{subscription.product_name}</b>
                                </div>
                                {subscription?.variant_name && (
                                    <div>
                                        <small>
                                            ({subscription?.variant_name}/
                                            {subscription?.variant_value})
                                        </small>
                                    </div>
                                )}
                            </div>
                        }
                        user={subscription.subscription_data?.user}
                        extension={subscription.subscription_data?.extension}
                        price={subscription.subtotal}
                        onRestore={() => {
                            onRestore(subscription_id);
                        }}
                        campaign_id={subscription?.subscription_data?.tcr_campaign_id}
                        phone_number={subscription?.subscription_data?.phone_number || subscription?.subscription_data?.phone}
                        restored={restored}
                        valid_revert_time={subscription.valid_revert_time}
                        price_schedule={subscription?.price_schedule}
                        discount_expiration_date={subscription?.discount_expiration_date}
                    />
                );
            })}
            recordsCount={count}
            recordsLimit={10}
            activePage={Number(params.get("page")) || 1}
            onPageChange={onPageChange}
            recordsName="Subscription"
            emptySubtitle=" "
            emptyListTitle={"No Subscriptions Added"}
        />
    );
};

export default SubscriptionsTable;
